<i [class.hidden]="!isLoading" class="fa fa-spin fa-spinner mini-loading" style="margin-left: 5px"></i>



// WEBPACK FOOTER //
// ./src/deps/pmv-common/pmv-common.d.ts.ɵl.html